var destinations = [
    {   destination: 'COXS BAZAR',
        description: "The longest natural unbroken sea beach in the world.....",
        image: "https://i.imgur.com/QKABM6x.jpg",
        detail: "Cox's Bazar (Bengali: কক্সবাজার) is a city, fishing port, tourism centre and district headquarters in southeastern Bangladesh. The beach in Cox's Bazar is the main attraction of the town with an unbroken length of 155 km (96 mi) also termed the longest natural unbroken sea beach in the world. "
    },
    {   destination: 'SREEMANGAL',
        description: "Sreemangal has been nicknamed the tea capital of Bangladesh....",
        image: "https://i.imgur.com/HsbnV0Z.png",
        detail: "Sreemangal has been nicknamed the tea capital of Bangladesh, due to the number of tea gardens in the area, and is the place of origin of the Seven Color Tea.[2] The Bangladesh Tea Research Institute in Sreemangal has made a number of contributions in evolving and standardising the quality of tea, and introducing its research findings to the tea industry of Bangladesh."
    },
    {   destination: 'SUNDARBANS',
        description: "The Sundarbans is a mangrove area in the delta ...",
        image: "https://i.imgur.com/0qU6FaW.png",
        detail: "The Sundarbans is a mangrove area in the delta formed by the confluence of the Ganges, Brahmaputra and Meghna Rivers in the Bay of Bengal.The Sundarbans are an important habitat for the Bengal tiger (Panthera tigris tigris). "
    }
];
export default destinations;